import { QueryKey } from '@tanstack/react-query';

import { MarketId } from '@arrived/models';

export const marketsKey: QueryKey = ['markets'];

export const marketsRoiKeyFn = (marketId: MarketId): QueryKey => marketsKey.concat([marketId, 'roi']);
export const marketsKeyFn = (marketId: MarketId): QueryKey => marketsKey.concat([marketId]);
